import { Link } from 'react-router-dom'
import { Container } from '@/components/ui'

interface EaseFinalCtaProps {
  onConsult: () => void
}

const EaseFinalCta = ({ onConsult }: EaseFinalCtaProps) => {
  return (
    <section className="pb-section" id="contact">
      <Container>
        <div className="eh-reveal grid items-center gap-8 border border-eh-border bg-eh-keylime px-5 py-8 sm:px-7 sm:py-10 md:grid-cols-[1fr_auto] md:gap-[42px] md:px-14 md:py-14">
          <div>
            <h2 className="eh-title max-w-[780px]">
              Sẵn sàng chọn lộ trình BA phù hợp và bắt đầu học?
            </h2>
            <p className="mt-4 max-w-xl text-base leading-relaxed text-eh-muted">
              Nhận tư vấn lộ trình qua Zalo hoặc xem ngay các khóa học để chọn lớp sắp khai giảng.
            </p>
          </div>
          <div className="flex flex-col gap-3 sm:flex-row md:flex-col">
            <button
              type="button"
              onClick={onConsult}
              className="eh-btn min-h-[56px] min-w-[190px] md:min-h-[72px] md:px-7"
            >
              Nhận tư vấn lộ trình <span className="eh-arrow">→</span>
            </button>
            <Link to="/courses" className="eh-btn-secondary min-h-[56px] min-w-[190px]">
              Xem khóa học đang mở
            </Link>
          </div>
        </div>
      </Container>
    </section>
  )
}

export default EaseFinalCta
